export const textileSustainableMap = {
	Composition: 'T001',
}

export enum QualityType {
	Sustainable = 1,
	Qualitative = 2,
}

export interface Quality {
	name: string
	type: QualityType
	minimumPercentage: number
	title: string
	subtitle: string
}

export const QualityMap: Record<string, Quality> = {
	recycledCotton: {
		name: 'recycledCotton',
		type: QualityType.Sustainable,
		minimumPercentage: 20,
		title: 'pdp.materials.recycledCotton.title',
		subtitle: 'pdp.materials.recycledCotton.subtitle',
	},
	organicCotton: {
		name: 'organicCotton',
		type: QualityType.Sustainable,
		minimumPercentage: 20,
		title: 'pdp.materials.organicCotton.title',
		subtitle: 'pdp.materials.organicCotton.subtitle',
	},
	regenerativeCotton: {
		name: 'regenerativeCotton',
		type: QualityType.Sustainable,
		minimumPercentage: 20,
		title: 'pdp.materials.regenerativeCotton.title',
		subtitle: 'pdp.materials.regenerativeCotton.subtitle',
	},
	recycledViscose: {
		name: 'circulose',
		type: QualityType.Sustainable,
		minimumPercentage: 20,
		title: 'pdp.materials.circulose.title',
		subtitle: 'pdp.materials.circulose.subtitle',
	},
	recycledWool: {
		name: 'recycledWool',
		type: QualityType.Sustainable,
		minimumPercentage: 20,
		title: 'pdp.materials.recycledWool.title',
		subtitle: 'pdp.materials.recycledWool.subtitle',
	},
	lyocell: {
		name: 'lyocell',
		type: QualityType.Sustainable,
		minimumPercentage: 100,
		title: 'pdp.materials.lyocell.title',
		subtitle: 'pdp.materials.lyocell.subtitle',
	},
	cashmere: {
		name: 'cashmere',
		type: QualityType.Qualitative,
		minimumPercentage: 20,
		title: 'pdp.materials.cashmere.title',
		subtitle: 'pdp.materials.cashmere.subtitle',
	},
	cupro: {
		name: 'cupro',
		type: QualityType.Qualitative,
		minimumPercentage: 20,
		title: 'pdp.materials.cupro.title',
		subtitle: 'pdp.materials.cupro.subtitle',
	},
	leather: {
		name: 'leather',
		type: QualityType.Qualitative,
		minimumPercentage: 20,
		title: 'pdp.materials.leather.title',
		subtitle: 'pdp.materials.leather.subtitle',
	},
	linen: {
		name: 'linen',
		type: QualityType.Qualitative,
		minimumPercentage: 20,
		title: 'pdp.materials.linen.title',
		subtitle: 'pdp.materials.linen.subtitle',
	},
	modal: {
		name: 'modal',
		type: QualityType.Qualitative,
		minimumPercentage: 100,
		title: 'pdp.materials.modal.title',
		subtitle: 'pdp.materials.modal.subtitle',
	},
	silk: {
		name: 'silk',
		type: QualityType.Qualitative,
		minimumPercentage: 20,
		title: 'pdp.materials.silk.title',
		subtitle: 'pdp.materials.silk.subtitle',
	},
	ramie: {
		name: 'ramie',
		type: QualityType.Qualitative,
		minimumPercentage: 100,
		title: 'pdp.materials.ramie.title',
		subtitle: 'pdp.materials.ramie.subtitle',
	},
	wool: {
		name: 'wool',
		type: QualityType.Qualitative,
		minimumPercentage: 20,
		title: 'pdp.materials.wool.title',
		subtitle: 'pdp.materials.wool.subtitle',
	},
	virginWool: {
		name: 'virginWool',
		type: QualityType.Qualitative,
		minimumPercentage: 20,
		title: 'pdp.materials.virginWool.title',
		subtitle: 'pdp.materials.virginWool.subtitle',
	},
}

export const QualitiesId: Record<string, Quality> = {
	'283': QualityMap.recycledCotton,
	'920': QualityMap.recycledCotton,
	'835': QualityMap.recycledCotton,
	'951': QualityMap.recycledCotton,
	'006': QualityMap.organicCotton,
	'890': QualityMap.organicCotton,
	'886': QualityMap.organicCotton,
	A09: QualityMap.organicCotton,
	'804': QualityMap.regenerativeCotton,
	'978': QualityMap.regenerativeCotton,
	'836': QualityMap.recycledViscose,
	'285': QualityMap.recycledWool,
	'929': QualityMap.recycledWool,
	'961': QualityMap.recycledWool,
	'288': QualityMap.lyocell,
	'812': QualityMap.lyocell,
	'081': QualityMap.lyocell,
	'811': QualityMap.lyocell,
	'813': QualityMap.lyocell,
	'814': QualityMap.lyocell,
	'016': QualityMap.cashmere,
	'290': QualityMap.cashmere,
	'905': QualityMap.cashmere,
	'922': QualityMap.cashmere,
	'046': QualityMap.cupro,
	'041': QualityMap.leather,
	'120': QualityMap.leather,
	'298': QualityMap.leather,
	'314': QualityMap.leather,
	'122': QualityMap.leather,
	'121': QualityMap.leather,
	'185': QualityMap.leather,
	'124': QualityMap.leather,
	'300': QualityMap.leather,
	'306': QualityMap.leather,
	'271': QualityMap.leather,
	'860': QualityMap.leather,
	'853': QualityMap.leather,
	'855': QualityMap.leather,
	'867': QualityMap.leather,
	'820': QualityMap.leather,
	'307': QualityMap.leather,
	'861': QualityMap.leather,
	'299': QualityMap.leather,
	'821': QualityMap.leather,
	'312': QualityMap.leather,
	'847': QualityMap.leather,
	'308': QualityMap.leather,
	'862': QualityMap.leather,
	'316': QualityMap.leather,
	'869': QualityMap.leather,
	'822': QualityMap.leather,
	'125': QualityMap.leather,
	'849': QualityMap.leather,
	'077': QualityMap.linen,
	'281': QualityMap.linen,
	'809': QualityMap.linen,
	'887': QualityMap.linen,
	'931': QualityMap.linen,
	'963': QualityMap.linen,
	'095': QualityMap.modal,
	'815': QualityMap.modal,
	'816': QualityMap.modal,
	'817': QualityMap.modal,
	'225': QualityMap.silk,
	'226': QualityMap.silk,
	'227': QualityMap.silk,
	'229': QualityMap.silk,
	'230': QualityMap.silk,
	'231': QualityMap.silk,
	'158': QualityMap.ramie,
	'071': QualityMap.wool,
	'808': QualityMap.wool,
	'194': QualityMap.virginWool,
}
